import * as c from "../utils/constants/constants";

const restrictTabs = () => {

  const isRestrictedPage = window.location.pathname.endsWith(c.PAGE_URLS[c.PAGE_TAB_RESTRICT]);
  const isDuplicateParam = window.location.search?.includes("duplicate");

  const TAB_PREFIX = 'myApp-tab-';
  const MAX_TABS = 1;

  if (sessionStorage.getItem('alreadyBooted')) {
    sessionStorage.removeItem('tabId');
  }

  let tabId = sessionStorage.getItem('tabId');
  if (!tabId) {
    tabId = `${TAB_PREFIX}${Date.now()}-${Math.random()}`;
    sessionStorage.setItem('tabId', tabId);
  }

  if (isDuplicateParam) return;

  sessionStorage.setItem('alreadyBooted', 'true');

  function registerTab() {
    const tabs = getActiveTabs();
    const isTabLimitExceeded = tabs.length >= MAX_TABS && !tabs.includes(tabId);
    if (isTabLimitExceeded && !isRestrictedPage) {
      blockTab();
    } else {
      localStorage.setItem(tabId, Date.now().toString());
    }
  }

  function getActiveTabs() {
    return Object.keys(localStorage).filter(key => key.startsWith(TAB_PREFIX));
  }
  function blockTab() {
    window.location.pathname = `/${c.PAGE_URLS[c.PAGE_TAB_RESTRICT]}`;
  }

  window.addEventListener('storage', (e) => {
    if (isRestrictedPage || isDuplicateParam) return;

    if (e.key && e.key.startsWith(TAB_PREFIX)) {
      const tabs = getActiveTabs();
      const isTabLimitExceeded = tabs.length > MAX_TABS && !tabs.includes(tabId);
      if (isTabLimitExceeded && !isRestrictedPage) {
        blockTab();
      }
    }
  });

  window.addEventListener('unload', () => {
    localStorage.removeItem(tabId);
    
  });

  window.addEventListener('load', () => {
    if (isRestrictedPage) {
      localStorage.removeItem(tabId);
  
      const tabs = getActiveTabs();
      if (tabs.length < MAX_TABS) {
        window.location.href = '/';
      }
    }
  });

  registerTab();
}

restrictTabs();
  
